import api from "./apiClient.js";

const endpoint = "actions";

export const getAllActions = () => {
	return api.get(endpoint);
};

export const runAction = (id) => {
	return api.put(endpoint + "/" + id);
};
